import { apiAxios } from '../utils/axios';

export const GetRequestsLeft = async (token: string) => {
  const config = {
    method: 'GET',
    url: '/get_ipchecker_requests',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  let data = await apiAxios.get(config.url, {
    headers: config.headers,
  });
  if (data) {
    return data.data;
  }
};
